export default {
  namespaced: true,
  state: {
    webSiteConfig: null,
    videoUrl: null,
    testPaperInfo: null,
    webSocketHost: process.env.WEBSOCKET_HOST,
    fileHost: process.env.FILE_HOST
  },

  mutations: {

    updateWebSiteConfig (state, webSiteConfig) {
      state.webSiteConfig = webSiteConfig
      sessionStorage.setItem('webSiteConfig', JSON.stringify(webSiteConfig))
    },

    updateTestPaperInfo (state, testPaperInfo) {
      state.testPaperInfo = testPaperInfo
      sessionStorage.setItem('testPaperInfo', JSON.stringify(testPaperInfo))
    },

    updateVideoUrl (state, data) {
      state.videoUrl = data
      sessionStorage.setItem('videoUrl', JSON.stringify(data))
    }

  },

  getters: {

    getWebSiteConfig (state) {
      if (state.webSiteConfig != null) {
        return state.webSiteConfig
      }
      return JSON.parse(sessionStorage.getItem('webSiteConfig'))
    },

    getTestPaperInfo (state) {
      if (state.testPaperInfo != null) {
        return state.testPaperInfo
      }
      return JSON.parse(sessionStorage.getItem('testPaperInfo'))
    },

    getVideoUrl (state) {
      if (state.videoUrl) {
        return state.videoUrl
      }
      return JSON.parse(sessionStorage.getItem('videoUrl'))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js